// components/MailSms/components/SendTab/LessonSelection.js
import React from 'react';
import { FiSearch, FiBook, FiCalendar } from 'react-icons/fi';
import { FixedSizeList as List } from 'react-window';
import LoadingSpinner from '../LoadingSpinner';

const ROW_HEIGHT = 124;
const LIST_HEIGHT = 384;

const LessonRow = ({ index, style, data }) => {
  const { lessons, selectedLessons, setSelectedLessons } = data;
  const lesson = lessons[index];

  return (
    <div style={style}>
      <label className="flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b">
        <input
          type="checkbox"
          checked={selectedLessons.includes(lesson.id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedLessons([...selectedLessons, lesson.id]);
            } else {
              setSelectedLessons(selectedLessons.filter(id => id !== lesson.id));
            }
          }}
          className="mr-3 text-purple-600 focus:ring-purple-500"
        />
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start gap-3">
            <div className="min-w-0">
              <p className="font-medium text-gray-800 truncate">{lesson.ogrenci_adi}</p>
              <p className="text-sm text-gray-600 truncate">
                <FiBook className="inline mr-1" />
                {lesson.ders_adi} - {lesson.ders_konusu}
              </p>
              <p className="text-xs text-gray-500 truncate">
                <FiCalendar className="inline mr-1" />
                {new Date(lesson.baslangic_tarihi).toLocaleDateString('tr-TR')} - {lesson.ders_sure} dk
              </p>
              <p className="text-xs text-purple-600 font-medium truncate">Öğretmen: {lesson.ogretmen_adi}</p>
              <p className="text-xs text-gray-500 truncate">Veli Tel: {lesson.parent_phone || 'Yok'}</p>
            </div>
            <div className="text-right shrink-0">
              {lesson.sms_status === 1 ? (
                <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                  SMS Gönderildi
                </span>
              ) : (
                <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
                  SMS Bekleniyor
                </span>
              )}
            </div>
          </div>
        </div>
      </label>
    </div>
  );
};

const LessonSelection = ({
  lessons,
  selectedLessons,
  setSelectedLessons,
  lessonSearchTerm,
  setLessonSearchTerm,
  dataLoading,
  pagination,
  onLoadMore
}) => {
  return (
    <>
      <h3 className="text-lg font-semibold mb-4">Ders Seçimi</h3>

      {/* Search */}
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Ders ara..."
          value={lessonSearchTerm}
          onChange={(e) => setLessonSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
        <FiSearch className="absolute left-3 top-3 text-gray-400" />
      </div>

      {/* List */}
      <div className="border rounded-lg bg-white overflow-hidden">
        {dataLoading.lessons ? (
          <LoadingSpinner />
        ) : lessons.length === 0 ? (
          <div className="p-6 text-center text-sm text-gray-500">
            Ders bulunamadı.
          </div>
        ) : (
          <List
            height={LIST_HEIGHT}
            itemCount={lessons.length}
            itemData={{ lessons, selectedLessons, setSelectedLessons }}
            itemSize={ROW_HEIGHT}
            width="100%"
          >
            {LessonRow}
          </List>
        )}
      </div>

      <div className="mt-4 flex justify-between items-center">
        <p className="text-sm text-gray-600">
          {selectedLessons.length} ders seçildi
        </p>
        {pagination?.hasNext && (
          <button
            onClick={onLoadMore}
            disabled={dataLoading.lessonsMore}
            className="mr-3 text-sm text-gray-600 hover:text-gray-800 disabled:text-gray-400"
          >
            {dataLoading.lessonsMore ? 'Yukleniyor...' : 'Daha Fazla'}
          </button>
        )}
        <button
          onClick={() => setSelectedLessons(lessons.filter(l => l.sms_status !== 1).map(l => l.id))}
          className="text-sm text-purple-600 hover:text-purple-700"
        >
          Gönderilmeyenleri Seç
        </button>
      </div>
    </>
  );
};

export default LessonSelection;
